import ApplicationController from './application_controller'

// Global debug function for testing
window.debugUpdateCartTotal = function(total) {
  console.log('DEBUG: Manually updating cart total to:', total)
  const cartTotalElement = document.querySelector('#cart-total')
  console.log('DEBUG: Found element:', cartTotalElement)
  if (cartTotalElement) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    cartTotalElement.textContent = formatter.format(total)
    console.log('DEBUG: Updated to:', cartTotalElement.textContent)
  }
}

export default class extends ApplicationController {
  static targets = ['quantity', 'total', 'removeButton', 'quantityBadge']
  static values = { 
    itemId: String,
    unitPrice: Number,
    updateUrl: String,
    removeUrl: String
  }

  connect() {
    super.connect()
    console.log('Cart item controller connected', this.element)
    console.log('Item ID:', this.itemIdValue)
    console.log('Update URL:', this.updateUrlValue)
    this.updateDisplay()
  }

  increment() {
    console.log('Increment clicked')
    const currentQty = parseInt(this.quantityTarget.value) || 0
    console.log('Current quantity:', currentQty)
    this.quantityTarget.value = currentQty + 1
    this.updateItem()
  }

  decrement() {
    console.log('Decrement clicked')
    const currentQty = parseInt(this.quantityTarget.value) || 0
    console.log('Current quantity:', currentQty)
    if (currentQty > 1) {
      this.quantityTarget.value = currentQty - 1
      this.updateItem()
    }
  }

  quantityChanged(event) {
    const quantity = parseInt(event.target.value) || 0
    if (quantity < 1) {
      event.target.value = 1
    }
    this.updateItem()
  }

  updateItem() {
    const quantity = parseInt(this.quantityTarget.value) || 0
    console.log('Updating item with quantity:', quantity)
    console.log('Update URL:', this.updateUrlValue)
    
    // Update local display immediately (optimistic update)
    this.updateDisplay()
    
    // Calculate and update the cart total immediately
    this.updateCartTotalsOptimistically()
    
    // Send update to server
    console.log('Sending PATCH request...')
    fetch(this.updateUrlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        quantity: quantity
      })
    })
    .then(response => {
      console.log('Response status:', response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      console.log('Response data:', data)
      if (data.success) {
        // Update the cart total from server response
        console.log('Cart data from server:', data.cart)
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        })
        
        // Update total
        if (data.cart && data.cart.total !== undefined) {
          const cartTotalElement = document.querySelector('#cart-total')
          console.log('Looking for #cart-total element...')
          console.log('Cart total element found:', cartTotalElement)
          console.log('Cart total value from server:', data.cart.total)
          if (cartTotalElement) {
            const formattedTotal = formatter.format(data.cart.total)
            console.log('Setting cart total to:', formattedTotal)
            console.log('Before update, element text:', cartTotalElement.textContent)
            cartTotalElement.textContent = formattedTotal
            console.log('After update, element text:', cartTotalElement.textContent)
          } else {
            console.log('Cart total element #cart-total not found in DOM')
            console.log('Available elements with IDs:', Array.from(document.querySelectorAll('[id]')).map(el => el.id))
          }
        } else {
          console.log('No cart.total in response. Cart data:', data.cart)
        }
        
        // Update subtotal
        if (data.cart && data.cart.subtotal !== undefined) {
          const cartSubtotalElement = document.querySelector('#cart-subtotal')
          if (cartSubtotalElement) {
            cartSubtotalElement.textContent = formatter.format(data.cart.subtotal)
          }
        }
        
        // Update item count
        if (data.cart && data.cart.item_count !== undefined) {
          const cartItemCountElement = document.querySelector('#cart-item-count')
          if (cartItemCountElement) {
            // Calculate total quantity from all items
            let totalQuantity = 0
            document.querySelectorAll('.cart-item input[data-cart-item-target="quantity"]').forEach(input => {
              totalQuantity += parseInt(input.value) || 0
            })
            cartItemCountElement.textContent = `Items (${totalQuantity})`
          }
        }
        
        // Update cart totals - dispatch on document so cart-totals controller can hear it
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }))
      } else {
        console.error('Update failed:', data.error)
        // Revert on error
        this.quantityTarget.value = data.previousQuantity || 1
        this.updateDisplay()
      }
    })
    .catch(error => {
      console.error('Error updating cart item:', error)
      alert('Failed to update cart. Please try again.')
    })
  }

  removeItem() {
    if (confirm('Remove this item from your cart?')) {
      // Store if this is the last item BEFORE removing
      const isLastItem = document.querySelectorAll('.cart-item').length === 1
      
      // Optimistically remove the item
      this.element.remove()
      
      // Update totals immediately only if not the last item
      // For last item, we'll handle it specially after server confirms
      if (!isLastItem) {
        this.updateCartTotalsOptimistically()
      }
      
      fetch(this.removeUrlValue, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Item already removed optimistically
          
          // If this was the last item, handle empty cart state
          if (isLastItem) {
            // Show empty cart message
            const cartItemsContainer = document.querySelector('.cart-items')
            const cartSummaryContainer = document.querySelector('.cart-summary')
            
            if (cartItemsContainer) {
              cartItemsContainer.innerHTML = `
                <div class="alert alert-info text-center">
                  <p class="mb-0">Your cart is empty. Add some items to get started!</p>
                </div>
              `
            }
            
            if (cartSummaryContainer) {
              // Update the summary to show empty cart
              const summaryBody = cartSummaryContainer.querySelector('.card-body')
              if (summaryBody) {
                summaryBody.innerHTML = '<p class="text-center text-muted mb-0">Your cart is empty.</p>'
              }
            }
            
            // Disable proceed to checkout button
            const checkoutButton = document.querySelector('a[href*="checkout"]')
            if (checkoutButton) {
              checkoutButton.classList.add('disabled')
              checkoutButton.style.pointerEvents = 'none'
              checkoutButton.onclick = (e) => e.preventDefault()
            }
          } else {
            // Not the last item, update totals normally
            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            })
            
            // Update the cart total from server response
            if (data.cart && data.cart.total !== undefined) {
              const cartTotalElement = document.querySelector('#cart-total')
              if (cartTotalElement) {
                cartTotalElement.textContent = formatter.format(data.cart.total)
              }
            }
            
            // Update subtotal
            if (data.cart && data.cart.subtotal !== undefined) {
              const cartSubtotalElement = document.querySelector('#cart-subtotal')
              if (cartSubtotalElement) {
                cartSubtotalElement.textContent = formatter.format(data.cart.subtotal)
              }
            }
            
            // Update item count
            const cartItemCountElement = document.querySelector('#cart-item-count')
            if (cartItemCountElement) {
              // Calculate total quantity from remaining items
              let totalQuantity = 0
              document.querySelectorAll('.cart-item input[data-cart-item-target="quantity"]').forEach(input => {
                totalQuantity += parseInt(input.value) || 0
              })
              cartItemCountElement.textContent = `Items (${totalQuantity})`
            }
          }
          
          // Update cart totals - dispatch on document so cart-totals controller can hear it
          document.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }))
        }
      })
      .catch(error => {
        console.error('Error removing cart item:', error)
      })
    }
  }

  updateDisplay() {
    const quantity = parseInt(this.quantityTarget.value) || 0
    const total = quantity * this.unitPriceValue

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = formatter.format(total)
    }

    // Update quantity badge
    if (this.hasQuantityBadgeTarget) {
      this.quantityBadgeTarget.textContent = quantity
      this.quantityBadgeTarget.style.display = quantity > 1 ? '' : 'none'
    }

    // Enable/disable decrement button
    const decrementButton = this.element.querySelector('[data-action*="decrement"]')
    if (decrementButton) {
      decrementButton.disabled = quantity <= 1
    }
  }

  updateCartTotalsOptimistically() {
    // Calculate the new subtotal from all visible items
    let subtotal = 0
    let totalQuantity = 0
    
    // Get all cart items and sum their totals
    document.querySelectorAll('.cart-item').forEach(item => {
      const totalElement = item.querySelector('[data-cart-item-target="total"]')
      const quantityInput = item.querySelector('[data-cart-item-target="quantity"]')
      
      if (totalElement) {
        // Parse the currency text to get the number
        const totalText = totalElement.textContent.replace(/[^0-9.-]+/g, '')
        subtotal += parseFloat(totalText) || 0
      }
      
      if (quantityInput) {
        totalQuantity += parseInt(quantityInput.value) || 0
      }
    })
    
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    
    // Update subtotal
    const cartSubtotalElement = document.querySelector('#cart-subtotal')
    if (cartSubtotalElement) {
      cartSubtotalElement.textContent = formatter.format(subtotal)
    }
    
    // Update item count
    const cartItemCountElement = document.querySelector('#cart-item-count')
    if (cartItemCountElement) {
      cartItemCountElement.textContent = `Items (${totalQuantity})`
    }
    
    // For total and fee coverage, we don't do optimistic updates here
    // because fee calculation happens server-side. The server response
    // will update the total and fee values via the cartUpdated event.
    // We only update the subtotal and item count optimistically.
  }
}